module.exports = "https://trybtryb-legacy.web.app/img/recipe.ec181cf3.svg";